/*
	
	PinUp!
	Pinning functionality for Fox Restaurant Concepts

	__________________________________________________

*/

(function($) {
	'use strict';

	$.fn.pinUp = function(params) {
		var yPos = 0,
			els = [],
			disabled = false,
			$window = $(window),
			ww = $(window).width();

		params = params || {};

		var getStyle = function($element, strStyle) {
			var styles = document.defaultView.getComputedStyle($element.get(0), null);
			return styles[strStyle];
		};

		var toRem = function(intValue) {
			if (parseFloat(intValue) == 0) {
				return '0';
			}
			else {
				return((parseFloat(intValue) / 16) + 'rem');
			}
		};

		var findContainer = function($element) {
			var container = $element.parent(),
				containerPos = getStyle(container, 'position');

			while (container.prop('tagName').toLowerCase() != 'body') {
				if (containerPos != 'static') {
					break;
				}

				container = container.parent();
				containerPos = getStyle(container, 'position');
			}

			return container;
		};

		var readPins = function(e) {
		//	console.log(e);
			for (var i =0; i < els.length; i++) {
				var $this = els[i],
					$container = params.container ? $this.closest(params.container) : findContainer($this),
					pad = { top: parseFloat(getStyle($container, 'padding-top')), bottom: parseFloat(getStyle($container, 'padding-bottom')) },
					$bumper = $('<div class="pinup-bumper"></div>'),
					offset = 0;

				if (params.offset && $(params.offset.element).length) {
					if (params.offset.prop) {
						offset = parseFloat(eval('$(\''+ params.offset.element +'\')'+ params.offset.prop));
					}
					else {
						offset = parseFloat($(params.offset.element).outerHeight());
					}
				}
				else if (params.offset && params.offset.value) {
					offset = parseFloat(params.offset.value);
				}

				$this.data('pinUp', {
					pinUp: true,
					pad: pad,
					offset: offset,
					container: $container,
					from: (params.container ? $container.offset().top : $this.offset().top) - pad.top - offset,
					to: $container.offset().top + $container.innerHeight() - $this.outerHeight() - pad.bottom - offset,
					end: $container.offset().top + $container.innerHeight(),
					parentTop: $container.innerHeight() - $this.outerHeight()
				});

				$bumper.css({
					height: toRem($this.outerHeight()),
					position: getStyle($this, 'position'),
					width: toRem($this.outerWidth())
				});

				if (!$container.has('.pinup-bumper').length) {
					$bumper.insertBefore($this);
				}
			}
		};

		var trackScroll = function() {
			if (params.disabled) { return; }

			yPos = $window.scrollTop();

			var elm = [];

			for (var i = 0; i < els.length; i++) {
				var $this = $(els[i]),
					props = $this.data('pinUp');

				if (!props.pinUp) { continue; }

				elm.push($this);

				var from = props.from - props.pad.bottom,
					to = props.to - props.pad.top;

			//	console.log(from +' '+ yPos +' '+ to);

				if (from < yPos && to > yPos) {
					$this.css({
						bottom: 'auto',
						position: 'fixed',
						top: toRem(props.pad.top + props.offset),
						transform: 'translate3d(0,0,0)'
					});

					props.container.find('.pinup-bumper').css({
						height: $this.outerHeight()
					}).addClass('active');

					if (params.class) {
						$this.addClass(params.class);
					}

					$this.trigger('pinUp-pinned', $this.data('pinUp'));
				}
				else if (yPos >= to) {
					$this.css({
						bottom: 0,
						top: 'auto',
						position: 'absolute',
						transform: 'translate3d(0,0,0)'
					});

					props.container.find('.pinup-bumper').css({
						height: $this.outerHeight()
					}).addClass('active');

					if (params.class) {
						$this.addClass(params.class);
					}

					$this.trigger('pinUp-end', $this.data('pinUp'));
				}
				else {
					$this.removeAttr('style');
					props.container.find('.pinup-bumper').removeClass('active');

					if (params.class) {
						$this.removeClass(params.class);
					}

					$this.trigger('pinUp-unpinned', $this.data('pinUp'));
				}
			}

			els = elm;
		};

		var updatePins = function(t) {
			readPins(t);
			trackScroll();
			$window.trigger('scroll');
			$window.triggerHandler('scroll');
		};

		this.each(function() {
			var $this = $(this),
				props = $(this).data('pinUp') || {};

			if (props && props.pinUp) {
				return;
			}

			els.push($(this));
			$(this).data('pinUp', props);
		});

		$window.on('resize', function() { // Because iOS 10 Safari will fire a resize event when scrolling as well
			if ($window.width() != ww) {
				updatePins('resize');
				ww = $(window).width();
			}
		});
		$window.on('scroll touchmove', function() { trackScroll(); });

		$window.one('load', function() { updatePins('load'); });

		updatePins('init');

		if (params.watchHandlers) {
			for (var i = 0; i < params.watchHandlers.length; i++) {
				$(params.watchHandlers[i].object).on(params.watchHandlers[i].event, function() { updatePins('event watcher'); });
			}
		}

		return this;
	};

})(jQuery);